<script>
import {http} from "../../../helpers/easyindustriaapi/config";
import {
  layoutMethods
} from "@/state/helpers";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Stat from "./widget";
import RevenueAnalytics from "./revenue";
import SalesAnalytics from "./sales-analytics";
import EarningReport from "./earning";
import Sources from "./sources";
import RecentActivity from "./recent-activity";
import RevenueLocation from "./revenue-location";
import Chat from "./chat";
import Transaction from './transaction';
import BirthdaysWeek from "./birthdays-week.vue";
import BirthdaysTomorrow from "./birthdays-tomorrow.vue";
import DashboardController from '@/controller/DashboardController';
import { userCanViewDashboardBlock, userHasDashboardSensitiveAnalytics } from '@/helpers/userPermissions'
import Swal from "sweetalert2";

/**
 * Dashboard component
 */
export default {
  components: {
    Layout,
    PageHeader,
    Stat,
    RevenueAnalytics,
    SalesAnalytics,
    EarningReport,
    Sources,
    RecentActivity,
    RevenueLocation,
    Chat,
    Transaction,
    BirthdaysWeek,
    BirthdaysTomorrow
  },
  data() {
    return {
      title: "Dashboard",
      items: [
        {
          text: "EasySaude"
        },
        {
          text: "Dashboard",
          active: true
        }
      ],
      loader: this.$store ? this.$store.state.layout.loader : {} || {},
      dashboardData: {
        statistics: null,
      }
    };
  },
  created() {
    this.currentUser = JSON.parse(localStorage.getItem('user'));
    this.dashboardController = new DashboardController();
    this.changeLoaderValue({
      loader: true,
    });
  },
  mounted() {
    this.loadDashboardData();
  },
  computed: {
    /** Gráficos e blocos com dados agregados sensíveis (alinhado à API). */
    showSensitiveDashboardBlocks() {
      return userHasDashboardSensitiveAnalytics(this.currentUser)
    },
    showStatisticsCard() {
      return userCanViewDashboardBlock(this.currentUser, 'dashboard.cards.statistics.view')
    },
    showRevenueAnalyticsCard() {
      return userCanViewDashboardBlock(this.currentUser, 'dashboard.cards.revenue-analytics.view')
    },
    showSalesAnalyticsCard() {
      return userCanViewDashboardBlock(this.currentUser, 'dashboard.cards.sales-analytics.view')
    },
    showEarningReportCard() {
      return userCanViewDashboardBlock(this.currentUser, 'dashboard.cards.earning-report.view')
    },
    showRecentActivityCard() {
      return userCanViewDashboardBlock(this.currentUser, 'dashboard.cards.recent-activity.view')
    },
    showTransactionCard() {
      return userCanViewDashboardBlock(this.currentUser, 'dashboard.cards.transaction.view')
    },
    showBirthdaysWeekCard() {
      return userCanViewDashboardBlock(this.currentUser, 'dashboard.cards.birthdays-week.view')
    },
    showBirthdaysTomorrowCard() {
      return userCanViewDashboardBlock(this.currentUser, 'dashboard.cards.birthdays-tomorrow.view')
    },
  },
  methods: {
    ...layoutMethods,
    async loadDashboardData() {
      Swal.fire({
        title: 'Aguarde...',
        text: 'Carregando dados do dashboard...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading(); // Exibe o loader enquanto a requisição está em andamento
        }
      });
      try {
        this.changeLoaderValue({ loader: true });
        const [
          statistics
        ] = await Promise.all([
          this.dashboardController.getStatistics(),
        ]);
        this.dashboardData = {
          statistics
        };
      } catch (error) {
        Swal.close();
        Swal.fire('Oops...', error.message, 'error');
        this.$toast.error(error.message);
      } finally {
        this.changeLoaderValue({ loader: false });
        Swal.close();
      }
    },
    async getData() {
      try {
        await http.get('user/'+this.currentUser.id)
          .then(res => {
            console.log(res);
          });
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.error('Usuário não tem permissão!');
        }

        if (error.response && error.response.status === 401) {
          this.error('Usuário não autenticado!');
        }
      }
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="showSensitiveDashboardBlocks">
      <div class="col-xl-8" id="stat-container">
        <Stat v-if="showStatisticsCard && dashboardData.statistics" :statistics="dashboardData.statistics" />
        <RevenueAnalytics v-if="showRevenueAnalyticsCard && dashboardData.statistics" :statistics="dashboardData.statistics" />
      </div>
      <div class="col-xl-4" id="sales-analytics-container">
        <SalesAnalytics v-if="showSalesAnalyticsCard && dashboardData.statistics" :statistics="dashboardData.statistics" />
        <EarningReport v-if="showEarningReportCard && dashboardData.statistics" :statistics="dashboardData.statistics" />
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4" id="sources-container" v-if="false">
        <Sources />
      </div>
      <div class="col-lg-4" id="revenue-location-container" v-if="false" >
        <RevenueLocation />
      </div>
    </div>
    <div class="row">      
      <div v-if="false" class="col-lg-4" id="chat-container">
        <Chat />
      </div>
      <div class="col-lg-6" id="recent-activity-container" v-if="showSensitiveDashboardBlocks && showRecentActivityCard">
        <RecentActivity v-if="dashboardData.statistics" :statistics="dashboardData.statistics" />
      </div>
      <div class="col-lg-6" id="transaction-container" v-if="showSensitiveDashboardBlocks && showTransactionCard">
        <Transaction v-if="dashboardData.statistics" :statistics="dashboardData.statistics" />
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12" id="birthdays-week-container" v-if="showBirthdaysWeekCard">
        <BirthdaysWeek />
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12" id="birthdays-tomorrow-container" v-if="showBirthdaysTomorrowCard">
        <BirthdaysTomorrow />
      </div>
    </div>
  </Layout>
</template>